module.exports = " <div class=dialogs> <div class=dialog v-bind:class=\"{ 'dialog-active': show }\"> <div class=dialog-content> <div class=\"close rotate\"> <span class=\"fa fa-times\" @click=close></span> </div> <slot name=header></slot> <slot name=body></slot> <slot name=footer></slot> </div> </div> <div class=dialog-overlay></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.5.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog.vue
// module id = 24
// module chunks = 2